<!-- 払い戻し金額 -->
<template>
  <div class="column">
    <!-- 料金 -->
    <label class="name">{{ $t("MyTicketTicketing.total") }}</label>

    <!-- 金額 -->
    <div v-if="isVisiblePrice" class="value">
      {{ amount }}{{ $t("common.unit") }}
    </div>
    <div v-else class="value">******</div>
  </div>
</template>

<script>
export default {
  name: "BgRefundAmount",
  props: {
    amount: {
      type: Number,
      required: true,
    },
    isVisiblePrice: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.column {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;
}

.column label {
  width: 110px;
  color: #888888;
}

.column .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
}
</style>
